"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LifecycleExpiration_1 = require("./_LifecycleExpiration");
var _Transition_1 = require("./_Transition");
var _NoncurrentVersionTransition_1 = require("./_NoncurrentVersionTransition");
var _NoncurrentVersionExpiration_1 = require("./_NoncurrentVersionExpiration");
var _AbortIncompleteMultipartUpload_1 = require("./_AbortIncompleteMultipartUpload");
exports._Rule = {
    type: "structure",
    required: ["Prefix", "Status"],
    members: {
        Expiration: {
            shape: _LifecycleExpiration_1._LifecycleExpiration
        },
        ID: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Status: {
            shape: {
                type: "string"
            }
        },
        Transition: {
            shape: _Transition_1._Transition
        },
        NoncurrentVersionTransition: {
            shape: _NoncurrentVersionTransition_1._NoncurrentVersionTransition
        },
        NoncurrentVersionExpiration: {
            shape: _NoncurrentVersionExpiration_1._NoncurrentVersionExpiration
        },
        AbortIncompleteMultipartUpload: {
            shape: _AbortIncompleteMultipartUpload_1._AbortIncompleteMultipartUpload
        }
    }
};
//# sourceMappingURL=_Rule.js.map